/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { colors, Heading, HFlow, Text, VFlow } from 'bold-ui'
import { MchatAplicacao, MChatPerguntaEnum } from 'graphql/types.generated'
import {
  MCHAT_PERGUNTAS,
  MCHAT_RESULTADOS,
} from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat/model-mchat'
import { PERGUNTAS_RISCO_SIM } from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat/util-mchat'

import HistoricoDetailTable from '../../../../table/HistoricoDetailTable'
import { MChat } from '../consulta/HistoricoObjetivoPecPanel'

interface HistoricoMChatTableBoxProps {
  mChat: MChat
  idadeEmMeses: number
}

export default function HistoricoMChatTableBox(props: HistoricoMChatTableBoxProps) {
  const { mChat, idadeEmMeses } = props

  return (
    <VFlow>
      <Heading level={3} style={classes.sectionHeading}>
        M-CHAT-R/F™ (Checklist Modificado para Autismo em Crianças Pequenas)
      </Heading>
      <HistoricoDetailTable hasLines>
        <VFlow style={classes.vflow}>
          <Heading level={5}>M-CHAT-R™</Heading>
          <HFlow justifyContent='space-between'>
            <Text fontWeight='bold'>Pergunta</Text>
            <HFlow hSpacing={0}>
              <Text fontWeight='bold' style={classes.rightColumns}>
                Resposta
              </Text>
              <Text fontWeight='bold' style={classes.rightColumns}>
                Pontuação
              </Text>
            </HFlow>
          </HFlow>
          {mChat.aplicacao.map((itemAplicacao: MchatAplicacao, index: number) => (
            <HFlow justifyContent='space-between' alignItems='center'>
              <HFlow hSpacing={0.2} style={classes.perguntaBox}>
                <Text style={classes.perguntaOrdinal}>{index + 1}.</Text>
                <Text>{MCHAT_PERGUNTAS[itemAplicacao.pergunta]}</Text>
              </HFlow>
              <HFlow hSpacing={0}>
                <Text fontWeight='bold' style={classes.rightColumns}>
                  {(PERGUNTAS_RISCO_SIM.includes(MChatPerguntaEnum[itemAplicacao.pergunta]) &&
                    itemAplicacao.stPassou) ||
                  (!PERGUNTAS_RISCO_SIM.includes(MChatPerguntaEnum[itemAplicacao.pergunta]) && !itemAplicacao.stPassou)
                    ? 'Não'
                    : 'Sim'}
                </Text>
                <Text fontWeight='bold' style={classes.rightColumns}>
                  {itemAplicacao.stPassou ? 0 : 1}
                </Text>
              </HFlow>
            </HFlow>
          ))}
          <HFlow justifyContent='flex-end' hSpacing={0}>
            <Text fontWeight='bold' style={classes.rightColumns}>
              Total de pontos
            </Text>
            <Text fontWeight='bold' style={classes.rightColumns}>
              {mChat.pontuacao}
            </Text>
          </HFlow>
          <VFlow vSpacing={0}>
            <Heading level={3} style={classes.footerItems}>
              Resultado:
            </Heading>
            <Heading level={3} style={classes.footerItems}>
              Risco {MCHAT_RESULTADOS[mChat.risco].shortTitle} | {'ponto'.pluralizeAndConcatValue(mChat.pontuacao)}
            </Heading>
            <Heading level={5}>Encaminhamento</Heading>
            <Text
              dangerouslySetInnerHTML={{ __html: MCHAT_RESULTADOS[mChat.risco].encaminhamento(idadeEmMeses) }}
              style={classes.encaminhamento}
            />
          </VFlow>
        </VFlow>
      </HistoricoDetailTable>
    </VFlow>
  )
}

const classes = {
  sectionHeading: css`
    color: ${colors.turquoise.c40};
  `,
  vflow: css`
    & div:nth-child(2) {
      border-bottom: 0;
      padding-bottom: 0.375rem;
    }
  `,
  rightColumns: css`
    width: 6rem;
    text-align: center;
  `,
  footerItems: css`
    margin-bottom: 0.5rem;
  `,
  perguntaBox: css`
    grid-template-columns: 1.25rem auto;
  `,
  perguntaOrdinal: css`
    text-align: right;
  `,
  encaminhamento: css`
    & strong {
      font-weight: normal;
    }
  `,
}
